
import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {completeNewPassword} from 'utils/auth/login';

import {Box, Stack, TextField, Typography, Button} from 'views/components';
import {LockResetOutlined} from 'views/icons';
import {translate, Translate} from 'views/module';

const ResetPasswordBox = (props) => {
  const {
    userData,

    userReload,
    statusProgressWrap: progressWrap,
    statusClear,
  } = props;

  const [password, setPassword] = React.useState('');
  const [isPasswordValid, setIsPasswordValid] = React.useState(false);
  const [isPasswordTouched, setIsPasswordTouched] = React.useState(false);

  const [rePassword, setRePassword] = React.useState('');
  const [isRePasswordValid, setIsRePasswordValid] = React.useState(false);
  const [isRePasswordTouched, setIsRePasswordTouched] = React.useState(false);

  const [loading, setLoading] = React.useState(false);


  const arePasswordsValid = isPasswordTouched && isPasswordValid && isRePasswordTouched && isRePasswordValid && password === rePassword;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!arePasswordsValid) {
      return;
    }

    progressWrap(async () => {
      setLoading(true);
      try {
        await completeNewPassword(userData, password);
        userReload();
        statusClear();
      } finally {
        setLoading(false);
      }
    }, {
      onErrorMessage: () => {
        return translate('auth.LoginFail');
      },
    });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
    >
      <Stack
        alignItems="center"
        spacing={{xs: 2, sm: 4}}
      >
        <LockResetOutlined
          sx={{
            height: {
              xs: 36, sm: 52,
            },
            width: {
              xs: 36, sm: 52,
            },
            color: 'text.contrast',
          }}
        />
        <Stack spacing={1} alignItems="center">
          <Typography variant="h4" fontWeight="normal" align="center" color="text.primary">
            <Translate expression='auth.Signup.UserAuth.ResetPassword.Title' />
          </Typography>
          <Typography variant="body1" color="text.primary" align="center">
            <Translate expression='auth.Signup.UserAuth.ResetPassword.Body' />
          </Typography>
        </Stack>
        <TextField
          label={translate('auth.Signup.UserAuth.ResetPassword.Password')}
          type='password'
          name='password'
          autoComplete='new-password'
          fullWidth
          value={password}
          onChange={setPassword}
          InputLabelProps={{shrink: true}}
          validation={{
            conditions: [[((val) => val.length >= 6), translate('auth.Signup.UserAuth.ResetPassword.Errors.Length')]],
            update: setIsPasswordValid,
            touch: () => setIsPasswordTouched(true),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
          size='medium'
        />
        <TextField
          label={translate('auth.Signup.UserAuth.ResetPassword.RePassword')}
          type='password'
          name='rePassword'
          autoComplete='new-password'
          fullWidth
          value={rePassword}
          onChange={setRePassword}
          InputLabelProps={{shrink: true}}
          validation={{
            conditions: [
              [((val) => val.length >= 6), translate('auth.Signup.UserAuth.ResetPassword.Errors.Length')],
              [((val) => val === password), translate('auth.Signup.UserAuth.ResetPassword.Errors.Match')],
            ],
            update: setIsRePasswordValid,
            touch: () => setIsRePasswordTouched(true),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
          size='medium'
        />
        <Button
          type='submit'
          variant={arePasswordsValid ? 'contained' : 'outlined'}
          fullWidth
          disabled={!arePasswordsValid}
          loading={loading}
          sx={{
            'py': 1,
            'borderRadius': 2,
            'textTransform': 'none',
            'backgroundColor': arePasswordsValid ? '#DA7955' : 'color.white',
            'color': arePasswordsValid ? 'color.white' : '#2D2925B8',
          }}
        >
          <Translate expression='auth.Signup.UserAuth.ResetPassword.Action' />
        </Button>
      </Stack>
    </Box>
  );
};

ResetPasswordBox.propTypes = {
  userData: PropTypes.object,

  statusProgressWrap: PropTypes.func.isRequired,
  statusClear: PropTypes.func.isRequired,
  userReload: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, dispatch)(React.memo(ResetPasswordBox));
